import { trustedRequest } from 'utils/request';

export const getTips = () => trustedRequest('/api/tips');
